import { useReceipt } from 'lib/hooks/queries/billing/useReceipt';

import ReceiptActionButtons from '../../ReceiptActionButtons';

const ReceiptSheetActions = ({ propsRef }) => {
  const { transactionId, appointmentId, eobId, token, viewDefaultReceipt, kioskDevice, isPatient } =
    propsRef.current;

  // Same key as ReceiptSheet's query, so this reads the already-fetched receipt rather
  // than firing a second request. EOB receipts carry no transactionId prop.
  const { data } = useReceipt({
    params: { transactionId, appointmentId, eobId, token },
    dependencies: [transactionId, appointmentId, eobId, token],
    options: { enabled: (!!transactionId || !!appointmentId || !!eobId) && viewDefaultReceipt }
  });

  return (
    <div className="flex items-center gap-2 pr-1">
      <ReceiptActionButtons
        transactionId={transactionId}
        emailTransactionId={transactionId || data?.receipt?.transaction?.id}
        appointmentId={appointmentId}
        token={token}
        channels={data?.deliveryChannels}
        kioskDevice={kioskDevice}
        isPatientSide={kioskDevice || isPatient}
      />
    </div>
  );
};

export default ReceiptSheetActions;
